<template>
  <div class="padding">
    <el-row>
      <el-col :span="24">
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="月份" prop="date">
            <el-date-picker
              v-model="searchForm.date"
              :editable="false"
              :clearable="false"
              format="yyyy-MM"
              value-format="yyyy-MM"
              type="month"
              placeholder="选择月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="H5游戏" prop="appKey">
            <el-select v-model="searchForm.appKey" placeholder="请选择">
              <el-option
                v-for="item in h5List"
                :key="item.appKey"
                :label="item.name"
                :value="item.appKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" native-type="submit" @click.native.prevent="submitSearch">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="24">
        <el-table :data="tableDate" :stripe="true" v-loading="loading" border show-summary>
          <el-table-column prop="appIndex" label="应用名称">
            <template slot-scope="scope">
              {{findAppName(scope.row.appIndex)}}
            </template>
          </el-table-column>
          <el-table-column prop="totalDiamondNum" label="总钻石数"></el-table-column>
          <el-table-column prop="money" label="总价(元)"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {getApps} from '@/api/apps'
  import {getGamesAll} from '@/api/games'
  import statistics from '@/api/statistics'
  // import constant from '@/utils/constant'
  import _Find_ from 'lodash/find'
  import moment from 'moment'

  function formatDate() {
    return moment().format('YYYY-MM')
  }

  export default {
    name: 'expenseUser',
    data() {
      return {
        searchForm: {
          date: formatDate(),
          appKey: ''
        },
        tableDate: [],
        apps: null,
        loading: false,
        h5List: []
      }
    },
    created() {
      // 加载APP
      getApps().then(apps => {
        if (apps) {
          this.apps = apps
        }
      })
      // 加载h5游戏列表
      getGamesAll().then(games => {
        if (games) {
          this.h5List = games;
        }
      })
    },
    methods: {
      submitSearch() {
        this.loadData({
          currentDate: this.searchForm.date,
          appKey: this.searchForm.appKey
        });
      },
      _Find_,
      findAppName(index) {
        return this._Find_(this.apps, {appIndex: index}).appName
      },
      /**
       * 调用api方法
       * @param data
       */
      loadData(data) {
        statistics.getTotalConsumeDiamond(data).then(result => {
          this.tableDate = result
        })
      }
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// totalConsumeDiamond.vue?1b6f44f9